/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import upload from './upload/saga';
import main from './main/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    main(),
    upload()
     ]);
}
